import { render, staticRenderFns } from "./extended.vue?vue&type=template&id=3c97780a"
import script from "./extended.vue?vue&type=script&lang=ts"
export * from "./extended.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports